<template>
    <dashboard-layout>
        <v-container fluid class="down-top-padding py-0">
            <BaseBreadcrumb
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
            ></BaseBreadcrumb>
            <v-row dense>
                <v-col cols="12">
                    <table-system-users></table-system-users>
                </v-col>
            </v-row>
        </v-container>
    </dashboard-layout>
</template>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import TableSystemUsers from './TableGrids/TableSystemUsers.vue'

export default {
    name: 'SystemUsers',
    props: {

    },
    components: {
        DashboardLayout,
        BaseBreadcrumb,
        TableSystemUsers,
    },
    data() {
        return {
            page: {
                title: "System Users",
            },
            breadcrumbs: [
                { text: "System Users", disabled: true },
            ],
        }
    },
    watch: {},
    computed: {},
    mounted: function () {},
    methods: {

    }
}
</script>
